module.exports = __webpack_public_path__ + "media/images/story_ranking_mailer/rank_no4-2f750468ec181e337688fb6ac5ef5235.png";